import cn from "classnames";
import { dateTimeToView } from "helpers/date";
import { hiddenUserData } from "helpers/hiddenData";
import { paths } from "helpers/paths";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import CommonReport from "./commonReport";

export default class BidPriceChangeReport extends CommonReport {
    expanderColumn = {
        expander: true,
        id: "expander",
        filterable: false,
        Cell: (props) => {
            const onClick = () => {
                props.modal({
                    name: "infoModal",
                    windowMod: "wide",
                    title: (
                        <a
                            data-bidid={props.value}
                            href={paths.bidShow("bid", props.row.values.bidId)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {props.row.values.bidId}
                        </a>
                    ),
                    body: props.renderRowSubComponent(props.row),
                });
            };
            return (
                <div className="cursor-pointer text-center" onClick={onClick}>
                    <i
                        className={cn("r-item__expander", {
                            "icon-uEAAE-angle-right-solid": !props.row.isExpanded,
                            "icon-uEA61-angle-down": props.row.isExpanded,
                        })}
                    />
                    <a
                        data-bidid={props.value}
                        href={paths.bidShow("bid", props.value)}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {props.value}
                    </a>
                </div>
            );
        },
    };

    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            Cell: (props) => {
                const { bidId } = props.row.values;
                const { id } = props.column;
                const uniqueId = { [`data-${props.column.id}`.toLowerCase()]: bidId };
                if (id === "bidId") {
                    return (
                        <a
                            data-bidid={props.value}
                            href={paths.bidShow("bid", props.value)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {props.value}
                        </a>
                    );
                }
                return <span {...uniqueId}>{formatValue(props.value, column.clrType)}</span>;
            },
            ...typeSpecificProps(column),
        };
    };

    extractColumns = () => {
        const { columns } = this.props.data || {};
        return [this.expanderColumn, this.idColumn].concat(columns.filter((item) => !!item.label).map(this.cellProps));
    };

    tableExtraProps = () => ({
        renderRowSubComponent: (row, isPrintForm) => {
            if (row.original.snapshots.length === 0) {
                return null;
            }
            const tableProps = isPrintForm
                ? {
                      className: "p-3 reports--bg-bluelight",
                      style: { minWidth: "100%", width: row.cells.reduce((acc, cell) => acc + cell.column.width, 0) },
                  }
                : {
                      className: "table-responsive",
                  };
            return (
                <div {...tableProps}>
                    <table className="table table-sm mb-0 border-bottom border-secondary bg-secondary">
                        <thead>
                            <tr className="table-active">
                                <th>#</th>
                                <th>Автор изменения</th>
                                <th>Дата и время изменения</th>
                                <th>Новое значение</th>
                                <th>Предыдущее значение</th>
                            </tr>
                        </thead>
                        <tbody>
                            {row.original.snapshots.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td data-userdisplayname={item.bidId + item.userDisplayName}>
                                        {item.userDisplayName}
                                    </td>
                                    <td data-createdat={item.bidId + item.userDisplayName}>
                                        {dateTimeToView(item.createdAt)}
                                    </td>
                                    <td data-newvalue={item.bidId + item.userDisplayName}>
                                        {hiddenUserData(formatValue(item.newValue, "double"), { type: "price" })}
                                    </td>
                                    <td data-previousvalue={item.bidId + item.userDisplayName}>
                                        {hiddenUserData(formatValue(item.previousValue, "double"), { type: "price" })}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        },
    });
}
